import { makeStyles } from "@material-ui/core/styles";
const useImportSlideModalStyles = makeStyles({
  modal: {
    margin: "auto",
    background: "white",
    height: "100vh",
    width: "780px",
  },
  body: {
    padding: "24px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: "white",
    "& .title": {
      display: "flex",
      gap: "16px",
      marginBottom: "20px",
      alignItems: "center",
      "& .icon": {
        display: "flex",
        justifyCotent: "center",
        marginInlineEnd: "16px",
        "& svg": {
          width: "25px",
          height: "25px",
          color: "white",
          margin: "auto",
        },
        "& .bg": {
          background: "rgb(0,100,216)",
          borderRadius: "32px",
          width: "48px",
          display: "flex",
          height: "48px",
        },
      },
      "& .titleText": {
        color: "#4C5157",
        fontFamily: "Dubai",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "20px",
        flexGrow: 1,
      },
      "& .closeIcon": {
        background: "#f1f1f2",
        color: "#8d8d8d",
        borderRadius: "50px",
        display: "flex",
        padding: "10px",
        cursor: "pointer",
        marginInlineStart: "16px",
      },
    },

    "& .content": {
      height: "100%",
      "& .header": {
        fontFamily: "Dubai",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "16px",
        color: "#4C5157",
        marginBottom: "20px",
      },
      "& .layouts": {
        display: "flex",
        flexFlow: "wrap",
        justifyContent: "start",
        gap: "22px",
        overflow: "auto",
        height: "100%",
        padding: "5px 5px 100px 5px",
      },
    },
  },

  slideTitle: {
    textOverflow: "ellipsis",
    fontFamily: "Dubai",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    position: "relative",
    top: "133px",
    textAlign: "center",
    justifyContent: "center",
    overflow: "hidden",
    width: "100%",
    whiteSpace: "nowrap",
    padding: "0px 5px 0px 5px",
  },

  slidePrev: {
    width: "220px",
    overflow: "hidden",

    "&:hover": {
      cursor: "pointer",
      background: "#9c9ea21a",
      borderRadius: "4px",
      outline: "1px solid rgb(6,156,240)",
    },
    "& .slideTitle": {},
    "& .thumb": {
      "& > div": {
        borderRadius: "20px",
      },
    },
  },
});

export default useImportSlideModalStyles;
